import type { ReactNode } from "react";
import { PASSWORD_ERROR_MESSAGES } from "../utils/passwordValidation";

interface PasswordRequirementsMessageProps {
  errorMessage: string;
}

/**
 * Component that displays password requirements and error messages.
 * Used when password validation fails to show detailed requirements.
 */
export const PasswordRequirementsMessage = ({
  errorMessage,
}: PasswordRequirementsMessageProps): ReactNode => {
  return (
    <div
      style={{
        fontSize: "0.85rem",
        width: "100%",
        maxWidth: "300px",
        padding: "10px",
        wordWrap: "break-word",
        overflowWrap: "break-word",
      }}
    >
      <div style={{ whiteSpace: "normal" }}>
        {PASSWORD_ERROR_MESSAGES[errorMessage] || errorMessage}
      </div>
      <hr
        style={{
          width: "100%",
          height: "1px",
          backgroundColor: "gray",
          border: "none",
          margin: "8px 0",
        }}
      />
      <div>Password must contain:</div>
      <ul
        style={{
          marginTop: "0.5rem",
          marginBottom: 0,
          paddingLeft: "20px",
        }}
      >
        <li>At least 1 uppercase letter</li>
        <li>At least 1 lowercase letter</li>
        <li>At least 1 number</li>
        <li>At least 1 special character</li>
        <li>Minimum 8 characters</li>
      </ul>
    </div>
  );
};
